import Duck from 'extensible-duck';
import Immutable from 'immutable';
import { toast } from 'react-toastify';

import requestsManagerAxios from '../../lib/requestsManagerAxios';
import handleServerError2 from '../../lib/functions/handleServerError2';

export default new Duck({
  namespace: 'public',
  store: 'page',
  types: [
    'UPDATE_PAGE',
    'UPDATE_PAGE_PENDING',
    'UPDATE_PAGE_REJECTED',
    'UPDATE_PAGE_FULFILLED',
  ],
  initialState: Immutable.fromJS({
    $$page: {},
    $$pageError: {},
    $$staffMembers: [],
    isSaving: false,
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.UPDATE_PAGE_PENDING:
        return $$state.merge({ isSaving: true });
      case types.UPDATE_PAGE_REJECTED:
        handleServerError2(payload);
        return $$state.merge({
          isSaving: false,
          $$pageError: Immutable.fromJS(payload.response.data || {}),
        });
      case types.UPDATE_PAGE_FULFILLED:
        toast.success('Saved.', { autoClose: 2000 });
        return $$state.merge({
          isSaving: false,
          $$pageError: Immutable.Map(),
          $$page: Immutable.fromJS(payload.data),
        });
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({
    updatePage: (id, page) => ({
      type: types.UPDATE_PAGE,
      payload: requestsManagerAxios.patch(`/admin/pages/${id}/newya`, { page }),
    }),
  }),
});
